(function () {
    'use strict';

    /* ── Navbar scroll effect ──────────────────────────────── */
    const navbar = document.querySelector('.navbar');
    if (navbar) {
        const onScroll = () => {
            navbar.classList.toggle('scrolled', window.scrollY > 40);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }

    /* ── Back to top button ────────────────────────────────── */
    const btnUp = document.querySelector('.float-btn-up');
    if (btnUp) {
        window.addEventListener('scroll', () => {
            btnUp.classList.toggle('visible', window.scrollY > 400);
        }, { passive: true });
        btnUp.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }

    /* ── Smooth scroll for anchor links ───────────────────── */
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            if (!href || href.length <= 1) return;
            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                const offset = 80;
                const top = target.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        });
    });

    /* ── Scroll-reveal animation ───────────────────────────── */
    const revealEls = document.querySelectorAll('[data-reveal]');
    if (revealEls.length) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-fadeup');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        revealEls.forEach(el => observer.observe(el));
    }

    /* ── Product gallery thumbnails (product page) ─────────── */
    const thumbs = document.querySelectorAll('.thumb-item');
    const carousel = document.getElementById('productCarousel');
    if (thumbs.length && carousel) {
        const bsCarousel = bootstrap.Carousel.getOrCreateInstance(carousel);

        thumbs.forEach((thumb, idx) => {
            thumb.addEventListener('click', () => {
                bsCarousel.to(idx);
            });
        });

        carousel.addEventListener('slid.bs.carousel', event => {
            thumbs.forEach((t, i) => t.classList.toggle('active', i === event.to));
        });
    }

    /* ── Order modal — pre-fill product + service type ─────── */
    const orderModal = document.getElementById('orderModal');
    if (orderModal) {
        // Pre-fill on open
        orderModal.addEventListener('show.bs.modal', event => {
            const trigger    = event.relatedTarget;
            const productName = trigger && trigger.dataset.product;
            const tch         = trigger && trigger.closest('[data-type]');
            const serviceType = (tch && tch.dataset.type) || 'op';

            // Hidden product input
            const inputProduct = orderModal.querySelector('#modalProductName');
            if (inputProduct) inputProduct.value = productName || '';

            // Product chip
            const chipRow  = orderModal.querySelector('#omProductRow');
            const chipText = orderModal.querySelector('#omProductChip');
            if (chipRow && chipText) {
                if (productName) {
                    chipText.textContent = productName;
                    chipRow.style.display = '';
                } else {
                    chipRow.style.display = 'none';
                }
            }

            // Service type toggle
            const typeInput = orderModal.querySelector('#modalServiceType');
            if (typeInput) typeInput.value = serviceType;
            orderModal.querySelectorAll('.om-type-btn').forEach(btn => {
                btn.classList.toggle('active', btn.dataset.type === serviceType);
            });

            // Reset form state (re-enable submit if was loading)
            const form = orderModal.querySelector('.js-order-form');
            if (form) {
                const btn = form.querySelector('[type=submit]');
                if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fa-solid fa-paper-plane me-2"></i>Отправить заявку'; }
            }
        });

        // Service type toggle buttons
        orderModal.addEventListener('click', function (e) {
            const typeBtn = e.target.closest('.om-type-btn');
            if (!typeBtn) return;
            orderModal.querySelectorAll('.om-type-btn').forEach(b => b.classList.remove('active'));
            typeBtn.classList.add('active');
            const typeInput = orderModal.querySelector('#modalServiceType');
            if (typeInput) typeInput.value = typeBtn.dataset.type || 'op';
        });
    }

    /* ── Simple form submit (demo — replace with real handler) */
/*    document.querySelectorAll('.js-order-form').forEach(form => {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            const btn = form.querySelector('[type=submit]');
            const original = btn.textContent;
            btn.disabled = true;
            btn.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Отправляем…';

            setTimeout(() => {
                form.innerHTML = `
          <div class="text-center py-4">
            <div style="font-size:3rem; color:#27ae60; margin-bottom:.8rem;">
              <i class="fa-solid fa-circle-check"></i>
            </div>
            <h5 class="fw-bold mb-2">Заявка отправлена!</h5>
            <p class="text-muted mb-0">Наш менеджер свяжется с вами в течение 15 минут.</p>
          </div>`;
            }, 1200);
        });
    });*/

    /* ── Catalog filter toggles (mobile) ───────────────────── */
    const filterToggle = document.querySelector('#filterToggle');
    const filterSidebar = document.querySelector('#filterSidebar');
    if (filterToggle && filterSidebar) {
        filterToggle.addEventListener('click', () => {
            filterSidebar.classList.toggle('d-none');
            filterSidebar.classList.toggle('d-block');
        });
    }

    /* ── Price range display ───────────────────────────────── */
    const priceRange = document.getElementById('priceRange');
    const priceVal = document.getElementById('priceVal');
    if (priceRange && priceVal) {
        priceRange.addEventListener('input', () => {
            priceVal.textContent = parseInt(priceRange.value).toLocaleString('ru-RU') + ' ₽';
        });
    }

    /* ── Counter animation for stats ──────────────────────── */
    const counters = document.querySelectorAll('[data-counter]');
    if (counters.length) {
        const counterObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                const el = entry.target;
                const target = parseInt(el.dataset.counter);
                const suffix = el.dataset.suffix || '';
                let current = 0;
                const step = Math.ceil(target / 60);
                const timer = setInterval(() => {
                    current = Math.min(current + step, target);
                    el.textContent = current.toLocaleString('ru-RU') + suffix;
                    if (current >= target) clearInterval(timer);
                }, 25);
                counterObserver.unobserve(el);
            });
        }, { threshold: 0.5 });
        counters.forEach(c => counterObserver.observe(c));
    }

    /* ── Catalog filter chips & sort ───────────────────────── */
    const filterForm = document.getElementById('catalogFilterForm');
    if (filterForm) {

        // Chip: click active → deselect; click inactive → select; then submit
        filterForm.querySelectorAll('.chip-label').forEach(function (label) {
            label.addEventListener('click', function (e) {
                e.preventDefault();
                var radio   = label.querySelector('.chip-radio');
                var group   = label.closest('[data-filter-slug]');
                var wasActive = label.classList.contains('active');

                // Clear all in group
                group.querySelectorAll('.chip-label').forEach(function (l) {
                    l.classList.remove('active');
                    l.querySelector('.chip-radio').checked = false;
                });

                // If wasn't active — activate; if was active — leave cleared (deselect)
                if (!wasActive) {
                    radio.checked = true;
                    label.classList.add('active');
                }

                filterForm.submit();
            });
        });

        // "Show all" toggle — switch class, not inline style (CSS has !important)
        filterForm.querySelectorAll('.chip-show-all').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var chips    = btn.closest('[data-filter-slug]');
                var expanded = btn.classList.toggle('expanded');
                chips.querySelectorAll('[data-chip-extra]').forEach(function (el) {
                    el.classList.toggle('chip-hidden', !expanded);
                });
                var arrow = btn.querySelector('.chip-arrow');
                if (arrow) arrow.innerHTML = expanded ? '&#8963;' : '&#8964;';
            });
        });

        // Sort buttons
        filterForm.querySelectorAll('.sort-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
                filterForm.querySelectorAll('.sort-btn').forEach(function (b) {
                    b.classList.remove('active');
                });
                btn.classList.add('active');
                document.getElementById('sortHidden').value = btn.dataset.sort;
                filterForm.submit();
            });
        });
    }

    /* ── City Selector ─────────────────────────────────────── */
    // Guard prevents double-init: _app_js.js is required by _app.js AND loaded standalone
    document.querySelectorAll('.city-sel:not([data-city-init])').forEach(function (sel) {
        sel.dataset.cityInit = '1';

        var btn       = sel.querySelector('.city-sel__btn');
        var drop      = sel.querySelector('.city-sel__drop');
        var searchEl  = sel.querySelector('.city-sel__search');
        var listEl    = sel.querySelector('.city-sel__list');
        var noResults = sel.querySelector('.city-sel__no-results');
        if (!btn) return;

        function closeSelector() {
            sel.classList.remove('open');
            btn.setAttribute('aria-expanded', 'false');
            if (searchEl) { searchEl.value = ''; filterCities(''); }
        }

        function filterCities(q) {
            if (!listEl) return;
            var items   = listEl.querySelectorAll('.city-sel__item');
            var visible = 0;
            items.forEach(function (item) {
                var match = !q || (item.dataset.cityName || '').includes(q);
                item.style.display = match ? '' : 'none';
                if (match) visible++;
            });
            if (noResults) noResults.style.display = visible === 0 ? '' : 'none';
        }

        // Toggle open / close
        btn.addEventListener('click', function (e) {
            e.stopPropagation();
            document.querySelectorAll('.city-sel.open').forEach(function (other) {
                if (other !== sel) other.classList.remove('open');
            });
            var opening = !sel.classList.contains('open');
            sel.classList.toggle('open');
            btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
            if (opening && searchEl) {
                setTimeout(function () { searchEl.focus(); }, 60);
            }
        });

        // Search input — filter city list
        if (searchEl) {
            searchEl.addEventListener('input', function () {
                filterCities(this.value.toLowerCase().trim());
            });
            searchEl.addEventListener('click', function (e) { e.stopPropagation(); });
            searchEl.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') closeSelector();
            });
        }

        // Prevent clicks inside dropdown from closing it
        if (drop) {
            drop.addEventListener('click', function (e) { e.stopPropagation(); });

            drop.querySelectorAll('.city-sel__item').forEach(function (item) {
                item.addEventListener('click', function () {
                    var newPrefix = item.dataset.cityPrefix || '';
                    var isDefault = item.dataset.cityDefault === '1';
                    var oldPrefix = sel.dataset.cityPrefix  || '';
                    var path      = window.location.pathname;
                    var search    = window.location.search;

                    if (oldPrefix) {
                        var re = new RegExp('^/' + oldPrefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(/|$)');
                        path = path.replace(re, '/');
                    }
                    if (!isDefault && newPrefix) {
                        path = '/' + newPrefix + (path.charAt(0) === '/' ? path : '/' + path);
                        path = path.replace(/\/\/+/g, '/');
                    }

                    window.location.href = path + search;
                });
            });
        }
    });

    /* ── Catalog view toggle (list / grid) ─────────────────── */
    if (!document._catalogViewInited) {
        document._catalogViewInited = true;
        const catalogRow = document.getElementById('catalogProductsRow');
        const viewBtns   = document.querySelectorAll('#catalogViewBtns .cvb');
        if (catalogRow && viewBtns.length) {
            const STORAGE_KEY = 'catalog_view';
            const applyView = (view) => {
                catalogRow.dataset.view = view;
                viewBtns.forEach(b => b.classList.toggle('active', b.dataset.view === view));
            };
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved === 'grid') applyView('grid');
            viewBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    const view = btn.dataset.view;
                    applyView(view);
                    localStorage.setItem(STORAGE_KEY, view);
                });
            });
        }
    }

    /* ── Spec collapse toggle ──────────────────────────────── */
    if (!document._specToggleListening) {
        document._specToggleListening = true;
        document.addEventListener('click', function (e) {
            // Main expand/collapse (grid view + mobile)
            const toggleBtn = e.target.closest('.tch__spec-toggle');
            if (toggleBtn) {
                const wrap = toggleBtn.closest('.tch__info') &&
                             toggleBtn.closest('.tch__info').querySelector('.tch__spec-wrap');
                if (!wrap) return;
                const open = wrap.classList.toggle('open');
                toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
                const label = toggleBtn.querySelector('.tch__spec-toggle-label');
                if (label) label.textContent = open ? 'Скрыть характеристики' : 'Все характеристики';
                return;
            }

            // "Show more" — items beyond 6
            const moreBtn = e.target.closest('.tch__spec-more');
            if (moreBtn) {
                const wrap  = moreBtn.closest('.tch__spec-wrap');
                const extra = wrap && wrap.querySelector('.tch__spec-extra');
                if (!extra) return;
                const open = extra.classList.toggle('open');
                moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
                const label   = moreBtn.querySelector('.tch__spec-more-label');
                const chevron = moreBtn.querySelector('.tch__spec-more-chevron');
                if (label)   label.textContent      = open ? 'Скрыть' : ('Ещё ' + (moreBtn.dataset.count || ''));
                if (chevron) chevron.style.transform = open ? 'rotate(180deg)' : '';
            }
        });
    }

    // Close on outside click (guard prevents duplicate listener)
    if (!document._citySelectorListening) {
        document._citySelectorListening = true;
        document.addEventListener('click', function () {
            document.querySelectorAll('.city-sel.open').forEach(function (sel) {
                sel.classList.remove('open');
                var btn = sel.querySelector('.city-sel__btn');
                var searchEl = sel.querySelector('.city-sel__search');
                if (btn) btn.setAttribute('aria-expanded', 'false');
                if (searchEl) { searchEl.value = ''; }
            });
        });
    }

})();

// ─── Quiz ────────────────────────────────────────────────────────────────────
(function () {
    var wrap = document.querySelector('.quiz-wrap');
    if (!wrap) return;

    var discounts = [];
    try { discounts = JSON.parse(wrap.dataset.discounts || '[]'); } catch (e) {}

    var answers = { tech: null, techLabel: null, duration: null, durationLabel: null, operator: null, operatorLabel: null };

    // Render duration options from config
    var durationContainer = document.getElementById('quiz-duration-opts');
    if (durationContainer && discounts.length) {
        discounts.forEach(function (d) {
            var btn = document.createElement('button');
            btn.className = 'quiz-opt';
            btn.type = 'button';
            btn.dataset.value   = String(d.min_days);
            btn.dataset.label   = d.label;
            btn.dataset.percent = String(d.percent || 0);
            btn.innerHTML = '<span class="quiz-opt-text">' + d.label + '</span>'
                + (d.percent > 0 ? '<span class="quiz-opt-discount">−' + d.percent + '%</span>' : '');
            durationContainer.appendChild(btn);
        });
    }

    function getDiscount(minDays) {
        var pct = 0;
        discounts.forEach(function (d) {
            if (minDays >= d.min_days) pct = d.percent || 0;
        });
        return pct;
    }

    function setStep(n) {
        wrap.querySelectorAll('.quiz-step').forEach(function (s) { s.classList.remove('active'); });
        var target = wrap.querySelector('[data-step="' + n + '"]');
        if (target) target.classList.add('active');

        var total  = 3;
        var fill   = n === 'result' ? 100 : Math.round((parseInt(n) / total) * 100);
        var progFill = wrap.querySelector('.quiz-progress-fill');
        var stepNum  = wrap.querySelector('.quiz-step-num');
        var progWrap = wrap.querySelector('.quiz-progress-wrap');
        if (progFill) progFill.style.width = fill + '%';
        if (stepNum)  stepNum.textContent = n === 'result' ? '✓' : n;
        if (progWrap) progWrap.style.display = n === 'result' ? 'none' : '';
    }

    function showResult() {
        var pct = 0;
        if (answers.duration !== null) pct = getDiscount(parseInt(answers.duration));

        // Сводка выбора
        var parts = [];
        if (answers.techLabel)     parts.push(answers.techLabel);
        if (answers.durationLabel) parts.push(answers.durationLabel);
        if (answers.operatorLabel) parts.push(answers.operatorLabel);
        var summary = parts.join(' · ');

        // Бейдж скидки
        var badge = document.getElementById('quizDiscountBadge');
        var discVal = document.getElementById('quizDiscountVal');
        if (badge)   badge.style.display = pct > 0 ? '' : 'none';
        if (discVal) discVal.textContent  = pct + '%';

        // Текст под заголовком результата
        var summaryEl = document.getElementById('quizResultSummary');
        if (summaryEl) summaryEl.textContent = summary;

        // product_name — реальная колонка в leads
        var productName = document.getElementById('quizInputProductName');
        if (productName) productName.value = summary;

        // discount — реальная колонка в leads
        var discInput = document.getElementById('quizInputDiscount');
        if (discInput) discInput.value = pct > 0 ? pct + '%' : '';

        var btn = document.querySelector('#quizForm button[type=submit]');
        if (btn) btn.innerHTML = pct > 0
            ? '<i class="fa-solid fa-paper-plane me-2"></i>Получить расчёт со скидкой ' + pct + '%'
            : '<i class="fa-solid fa-paper-plane me-2"></i>Получить расчёт';

        setStep('result');
    }

    wrap.addEventListener('click', function (e) {
        // Back buttons
        var back = e.target.closest('.quiz-back-btn');
        if (back) {
            setStep(parseInt(back.dataset.back));
            return;
        }

        // Option buttons
        var opt = e.target.closest('.quiz-opt');
        if (!opt) return;

        var step = opt.closest('.quiz-step');
        if (!step) return;
        var stepNum = step.dataset.step;

        // Deselect siblings
        step.querySelectorAll('.quiz-opt').forEach(function (b) { b.classList.remove('selected'); });
        opt.classList.add('selected');

        if (stepNum === '1') {
            answers.tech      = opt.dataset.value;
            answers.techLabel = opt.dataset.label || opt.querySelector('.quiz-opt-text').textContent.trim();
            setTimeout(function () { setStep(2); }, 220);
        } else if (stepNum === '2') {
            answers.duration      = opt.dataset.value;
            answers.durationLabel = opt.dataset.label || opt.querySelector('.quiz-opt-text').textContent.trim();
            setTimeout(function () { setStep(3); }, 220);
        } else if (stepNum === '3') {
            answers.operator      = opt.dataset.value;
            answers.operatorLabel = opt.dataset.label || opt.querySelector('.quiz-opt-text').textContent.trim();
            setTimeout(function () { showResult(); }, 220);
        }
    });
}());
